import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import blueGrey from '@material-ui/core/colors/blueGrey';
import grey from '@material-ui/core/colors/grey';
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import * as React from 'react';
import * as Stickyfill from 'stickyfilljs';
import { CMItemCode, isValid } from '../utils/CMData';

import SkillResult from 'src/containers/SkillResult';
import SkillOnGoing from '../containers/SkillOnGoing';
import i18n from '../resources/i18n';

const styles = (theme: Theme) =>
	createStyles({
		accessBar: {
			marginTop: theme.spacing(1),
			position: 'sticky',
			top: theme.spacing(1),
			zIndex: 10,
		},
		accessButton: {
			textTransform: 'none',
			[theme.breakpoints.down('sm')]: {
				fontSize: '0.625rem',
			},
		},
		accessor: {
			backgroundColor: 'rgba(55,71,79,0.5)',
			borderBottomLeftRadius: '1em',
			borderTopLeftRadius: '1em',
			color: grey[50],
			paddingBottom: theme.spacing(1),
			paddingLeft: theme.spacing(2),
			paddingRight: theme.spacing(1),
			paddingTop: theme.spacing(1),
		},
		bottomNavigation: {
			backgroundColor: blueGrey[50],
			bottom: 0,
			position: 'fixed',
			width: '100%',
		},
		hidden: {
			visibility: 'hidden',
		},
		root: {
			padding: theme.spacing(1),
		},
	});

export interface ISkillAdminViewProps {
	adminView: boolean;
	userId: string;
}

interface IProps
	extends React.Props<{}>,
		WithStyles<typeof styles>,
		ISkillAdminViewProps {}
interface IState {
	careerTypeON: boolean;
	tabNumber: number;
}

/**
 * 実施状況メインコンポーネント
 */
class SkillMain extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			careerTypeON: true,
			tabNumber: 0,
		};
	}
	public render() {
		const { classes } = this.props;

		return (
			<div className={classes.root}>
				<Tabs
					value={this.state.tabNumber}
					onChange={this.handleChange}
					indicatorColor="primary"
					textColor="primary"
					centered={true}
				>
					<Tab label={i18n.t('SkillMain_0001')} />
					<Tab label={i18n.t('SkillMain_0002')} />
				</Tabs>
				{isValid(CMItemCode.CM_SKILLMAP_ENABLED) && (
					<Grid
						container={true}
						justify="flex-end"
						className={classes.accessBar}
						ref={(el: HTMLDivElement) => el && Stickyfill.add(el)}
					>
						<Grid item={true}>
							<div className={classes.accessor}>
								<ButtonGroup
									variant="contained"
									color="primary"
									size="small"
								>
									<Button
										className={classes.accessButton}
										onClick={this.handlNavigate()}
									>
										<ArrowUpwardIcon />
									</Button>
									<Button
										className={classes.accessButton}
										onClick={this.handlNavigate('skill')}
									>
										{i18n.t('SkillMain_0003')}
									</Button>
									<Button
										className={classes.accessButton}
										onClick={this.handlNavigate('skillmap')}
									>
										{i18n.t('SkillMain_0004')}
									</Button>
								</ButtonGroup>
							</div>
						</Grid>
					</Grid>
				)}
				{this.state.tabNumber === 0 && (
					<SkillOnGoing
						adminView={this.props.adminView}
						userId={this.props.userId}
					/>
				)}
				{this.state.tabNumber === 1 && (
					<SkillResult
						adminView={this.props.adminView}
						userId={this.props.userId}
					/>
				)}
			</div>
		);
	}

	/**
	 * タブ変更ハンドラ
	 */
	protected handleChange = (event: React.ChangeEvent<{}>, value: any) => {
		this.setState({ tabNumber: value });
	};

	/**
	 * ナビゲーションハンドラ
	 */
	protected handlNavigate = (targetId?: string) => (
		event: React.MouseEvent
	) => {
		if (!targetId) {
			window.scrollTo({
				behavior: 'smooth',
				top: 0,
			});
			return;
		}

		const target = document.querySelector('div#' + targetId);
		if (!target) {
			return;
		}
		target.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
			inline: 'nearest',
		});
	};
}

export default withStyles(styles)(SkillMain) as React.ComponentType<
	ISkillAdminViewProps
>;



// WEBPACK FOOTER //
// ./src/components/SkillMain.tsx